<template>
	<div>
		<div class="setting-container">
			  <el-radio-group class="type-radio-group" v-model="dateType" size="mini" @change="changeDateType">
				<el-radio-button label="1">近7天</el-radio-button>
				<el-radio-button label="2">近30天</el-radio-button>
				<el-radio-button label="3">今年</el-radio-button>
			  </el-radio-group>
			  <el-date-picker
				v-model="timeRange"
				@change="getList"
				size="mini"
				type="daterange"
				range-separator="至"
				start-placeholder="开始日期"
				end-placeholder="结束日期"
				style="margin-right: 12px;">
			  </el-date-picker>
			  <div style="width: 220px;">
				  <el-input v-model="pagination.phone_number" @change="getList" @keydown.enter="getList" size="mini" placeholder="请输入手机号">
					  <template slot="append">
						  <el-button type="primary" size="mini" icon="el-icon-search" @click="getList"></el-button>
					  </template>
				  </el-input>
			  </div>
		</div>
		<div>
			<!-- 表格 -->
			<el-table border stripe
			  :data="dataList"
			  style="width: 100%">
			  <el-table-column
			    type="index"
			    label="#"
			    width="100">
			  </el-table-column>
			  <el-table-column
			    prop="nickname"
			    label="用户昵称"
			    width="180">
			  </el-table-column>
			  <el-table-column
			    prop="phone_number"
			    label="手机号"
			    width="180">
			  </el-table-column>
			  <el-table-column
			    prop="version_name"
			    label="版本" >
			  </el-table-column>
			  <el-table-column
			    prop="total_times"
			    label="使用总数">
			  </el-table-column>
			  <el-table-column
			    prop="type"
			    label="详情">
				<template slot-scope="scope">
					<div>
						<span v-for="(item,index) in scope.row.type">
							<span>{{apiMap[index] || index}}</span>: <span>{{item}}</span>
						</span>
					</div>
				</template>
			  </el-table-column>
			</el-table>
			<!-- 分页 -->
			<div style="padding: 15px 0; text-align: right;">
				<el-pagination :hide-on-single-page="true" background @current-change="handleCurrentChange"
					:current-page="pagination.page" :page-size="pagination.page_size"
					layout="total, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				dateType: '1',
				timeRange: [],
				dataList: [],
				pagination: {
					page: 1,
					page_size: 15,
					phone_number: ''
				},
				total: 1,
				apiMap: {
					'generate': '渲图',
					'blend': '安装合成',
					'remove': '门窗擦除',
					'renovate': '室内装修',
					'exterior': '别墅',
					'removeFence': '去围栏',
					'unrenovate_url': '变毛坯'
				}
			}
		},
		methods: {
			getList() {
				var params = {
					start_time: this.timeRange[0] ? moment(this.timeRange[0]).format('YYYY-MM-DD') : "",
					end_time: this.timeRange[1] ? moment(this.timeRange[1]).format('YYYY-MM-DD') : '',
					...this.pagination
				}
			  this.$axios.get("operation/rendering-data",params).then(res => {
			    if (res.code == 1) {
			       console.log(res)
				   this.dataList = res.data.data
				   this.total = res.data.total
			    }
			  });
			},
			changeDateType(n) {
				var now = new Date()
				var start = new Date()
				if(n == '1') {
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
				}else if(n == '2') {
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
				}else{
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
				}
				this.timeRange = [start,now]
				this.getList()
			},
			handleCurrentChange(page) {
				this.pagination.page = page;
				this.getList();
			},
		},
		mounted() {
			var now = new Date(),start = new Date()
			var start = start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
			this.timeRange = [start,now]
			this.getList()
		}
	}
</script>

<style scoped lang="scss">
	.setting-container{
		padding: 20px 0 10px;
		border-bottom: 8px solid #DCDFE6;
		margin-bottom: 20px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
	.type-radio-group{
		margin: 10px 0;
		.el-radio-button{
			margin-right: 12px;
			/deep/ .el-radio-button__inner{
				border-left: 1px solid #DCDFE6;
				border-radius: 4px;
			}
			/deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
				border-left: 1px solid #409EFF;
			}
		}
	}
	.stastic-line{
		padding-bottom: 20px;
		border-bottom: 8px solid #DCDFE6;
		.el-col{
			text-align: center;
			h5{
				font-size: 24px;
				margin: 24px 0 2px;
			}
			p{
				font-size: 14px;
				color: rgb(102,102,102);
			}
			.icon-img{
				width: 12px;
				height: 12px;
				margin-left: 6px;
			}
		}
		
	}
</style>